import React from 'react'
import { ShoppingBag, FileText, Users } from 'lucide-react'

interface TransactionItemProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  description: string;
  amount: string;
  color: string;
  darkMode: boolean;
}

const TransactionItem: React.FC<TransactionItemProps> = ({ icon: Icon, description, amount, color, darkMode }) => (
  <li className="flex items-center justify-between py-3">
    <div className="flex items-center">
      <Icon className={`mr-3 h-5 w-5 ${color}`} />
      <span className={`text-sm md:text-base ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>{description}</span>
    </div>
    <span className={`text-sm md:text-base font-semibold ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>{amount}</span>
  </li>
)

interface TransactionListProps {
  darkMode: boolean;
}

const TransactionList: React.FC<TransactionListProps> = ({ darkMode }) => {
  return (
    <div className={`rounded-lg shadow p-4 md:p-6 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
      <h2 className={`text-lg md:text-xl font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-800'}`}>Dernières transactions</h2>
      <ul>
        <TransactionItem icon={ShoppingBag} description="Ce bon resto" amount="- 17,90 EUR" color="text-blue-500" darkMode={darkMode} />
        <TransactionItem icon={FileText} description="Direction Générale D..." amount="- 82,00 EUR" color={darkMode ? 'text-gray-400' : 'text-gray-500'} darkMode={darkMode} />
        <TransactionItem icon={FileText} description="Impôts" amount="- 957,00 EUR" color={darkMode ? 'text-gray-400' : 'text-gray-500'} darkMode={darkMode} />
        <TransactionItem icon={ShoppingBag} description="Achat ordinateur" amount="- 1335,88 EUR" color="text-blue-500" darkMode={darkMode} />
        <TransactionItem icon={Users} description="John Doe Company" amount="- 1500,72 EUR" color="text-green-500" darkMode={darkMode} />
        <TransactionItem icon={FileText} description="Qonto (facturation)" amount="- 10,80 EUR" color={darkMode ? 'text-gray-400' : 'text-gray-500'} darkMode={darkMode} />
      </ul>
    </div>
  )
}

export default TransactionList